
import React, { ReactNode } from 'react';
import { useTranslatedContent } from '@/hooks/useTranslatedContent';

interface TranslatedTextProps {
  children: string;
  as?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
  className?: string;
  skipTranslation?: boolean;
}

/**
 * A component that automatically translates its text content
 */
const TranslatedText = ({ 
  children, 
  as: Component = 'span', 
  className = '',
  skipTranslation = false
}: TranslatedTextProps) => {
  const { translatedContent, isLoading } = useTranslatedContent(children, { skipTranslation });
  
  // Handle custom components or elements
  if (typeof Component !== 'string') {
    return <Component className={className}>{translatedContent}</Component>;
  }
  
  // Create the element with the appropriate props
  const props: any = {
    className: `${className} ${isLoading ? 'opacity-70' : ''}`,
    children: translatedContent
  };
  
  // Handle standard HTML elements
  return React.createElement(Component, props);
};

export default TranslatedText;
